(function () {
  "use strict";

  var root = document.querySelector("[data-mega-menu-grow-collection]");
  if (!root) return;

  /* ---------- Colonne pilote : bascule des rubriques ---------- */
  var tabs = Array.prototype.slice.call(root.querySelectorAll(".mm-pilot__item"));
  var panels = Array.prototype.slice.call(root.querySelectorAll(".mm-panel"));

  function activateTab(target) {
    tabs.forEach(function (tab) {
      var active = tab.getAttribute("data-mm-tab") === target;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
    });
    panels.forEach(function (panel) {
      var active = panel.getAttribute("data-mm-panel") === target;
      panel.classList.toggle("is-active", active);
      if (active) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    });
    hideMulti();
    if (target !== "forme") resetAside();
    if (target === "teinte") preloadTeinteImages();
  }

  tabs.forEach(function (tab) {
    var target = tab.getAttribute("data-mm-tab");
    tab.addEventListener("mouseenter", function () {
      activateTab(target);
    });
    tab.addEventListener("focus", function () {
      activateTab(target);
    });
  });

  /* ---------- Aperçu produit : suit le survol des modèles ---------- */
  var asideImage = root.querySelector("#mm-aside-image");
  var asideHomme = root.querySelector("#mm-aside-homme");
  var asideFemme = root.querySelector("#mm-aside-femme");
  var asideNom = root.querySelector("#mm-aside-nom");
  var asideForme = root.querySelector("#mm-aside-forme");
  var asideColorisNb = root.querySelector("#mm-aside-coloris-nb");
  var asideColorisDots = root.querySelector("#mm-aside-coloris-dots");
  var asideLink = root.querySelector("#mm-aside-link");
  var asideCta = root.querySelector("#mm-aside-cta");
  var asideGallery = root.querySelector(".mm-aside__gallery");
  var asideMeta = asideNom ? asideNom.closest(".mm-aside__meta") : null;
  var asideColors = root.querySelector(".mm-aside__colors");
  var asideFooter = root.querySelector(".mm-aside__footer");
  var asideMulti = root.querySelector("#mm-aside-multi");
  var multiSlots = asideMulti ? Array.prototype.slice.call(asideMulti.querySelectorAll("[data-mm-multi-slot]")) : [];
  var asideTimer = null;
  var multiTimer = null;
  var currentModel = asideNom ? asideNom.textContent.trim() : "";
  var currentKey = currentModel;
  var currentMultiKey = "";

  var defaultModel = root.hasAttribute("data-mm-default")
    ? JSON.parse(root.getAttribute("data-mm-default"))
    : null;

  var PALETTE = {
    noir: "#161616",
    "noir-orange": "linear-gradient(135deg,#161616 50%,#D2691E 50%)",
    ambre: "#B07A2B",
    creme: "#EDE4D3",
    sable: "#D9C7A8",
    marron: "#6E4B2A",
    gris: "#8A8C8E",
    smoked: "#6E6E6E",
    bleu: "#3F5E86",
    "bleu-2": "#2F4A7A",
    "bleu-full": "#22406E",
    "bleu-ciel": "#9FC3DC",
    "bleu-argent": "#B9C4CC",
    "bleu-or": "#C1A16A",
    "bleu-transparent": "#BBD3E5",
    "transparent-bleu": "#CFE0EC",
    "bleu-vert": "#3F7E82",
    vert: "#4C6B4A",
    "vert-clair": "#8FAE7E",
    "vert-or": "#8E8B4A",
    rose: "#D69C9C",
    "rose-vert": "linear-gradient(135deg,#D69C9C 50%,#4C6B4A 50%)",
    mauve: "#9B87A8",
    violet: "#7B5EA7",
    orange: "#D2691E",
    jaune: "#D9A62E",
    rouge: "#A63232",
    turquoise: "#3FA9A0",
    tea: "#8B6B4F",
    clear: "linear-gradient(135deg,#FFFFFF,#E4E9EC)",
    leopard: "linear-gradient(135deg,#C99A5B,#7A4B22,#C99A5B)",
    "jaune-leopard": "linear-gradient(135deg,#E0B44E,#7A4B22,#E0B44E)",
    "orange-leopard": "linear-gradient(135deg,#D2691E,#7A4B22,#D2691E)",
    "jaune-noir": "linear-gradient(135deg,#D9A62E 50%,#161616 50%)",
    "marron-bleu": "linear-gradient(135deg,#6E4B2A 50%,#3F5E86 50%)",
    degrade: "linear-gradient(135deg,#7B5EA7,#D9A62E)"
  };
  var MAX_DOTS = 9;

  function renderColors(count, tones) {
    if (!asideColorisNb || !asideColorisDots) return;
    if (!count) {
      asideColorisNb.textContent = "";
      asideColorisDots.innerHTML = "";
      return;
    }
    asideColorisNb.textContent = count + (count > 1 ? " coloris" : " coloris");
    var list = (tones || "").split(",").filter(Boolean);
    var visible = list.slice(0, MAX_DOTS);
    var html = visible
      .map(function (tone, index) {
        var fill = PALETTE[tone] || "#C9C4BC";
        return '<i style="background:' + fill + ";animation-delay:" + index * 22 + 'ms"></i>';
      })
      .join("");
    if (list.length > visible.length) {
      html += '<span>+' + (list.length - visible.length) + "</span>";
    }
    asideColorisDots.innerHTML = html;
  }

  function setAsideImages(homme, femme, img, alt) {
    [asideImage, asideHomme, asideFemme].forEach(function (el) {
      if (el) el.classList.remove("is-visible");
    });
    clearTimeout(asideTimer);
    asideTimer = setTimeout(function () {
      if (asideImage && img) {
        asideImage.src = img;
        asideImage.alt = alt;
      }
      if (asideHomme && homme) {
        asideHomme.src = homme;
        asideHomme.alt = "Homme portant le modèle " + alt;
      }
      if (asideFemme && femme) {
        asideFemme.src = femme;
        asideFemme.alt = "Femme portant le modèle " + alt;
      }
      [asideImage, asideHomme, asideFemme].forEach(function (el) {
        if (el) el.classList.add("is-visible");
      });
    }, 110);
  }

  function setAsideLink(url) {
    if (!url) return;
    if (asideLink) asideLink.setAttribute("href", url);
    if (asideCta) asideCta.setAttribute("href", url);
  }

  function updateAside(link) {
    var nom = link.getAttribute("data-mm-nom");
    var img = link.getAttribute("data-mm-img");
    var key = nom + ":" + img;
    if (key === currentKey) return;
    currentKey = key;
    currentModel = nom;
    if (asideNom) asideNom.textContent = nom;
    if (asideForme) asideForme.textContent = link.getAttribute("data-mm-forme");
    renderColors(link.getAttribute("data-mm-coloris"), link.getAttribute("data-mm-teintes"));
    setAsideLink(link.getAttribute("href"));
    setAsideImages(link.getAttribute("data-mm-homme"), link.getAttribute("data-mm-femme"), img, nom);
  }

  function resetAside() {
    if (!defaultModel) return;
    var key = defaultModel.nom + ":" + defaultModel.img;
    if (key === currentKey) return;
    currentKey = key;
    currentModel = defaultModel.nom;
    if (asideNom) asideNom.textContent = defaultModel.nom;
    if (asideForme) asideForme.textContent = defaultModel.forme;
    renderColors(defaultModel.coloris, defaultModel.teintes);
    setAsideLink(defaultModel.url);
    setAsideImages(defaultModel.homme, defaultModel.femme, defaultModel.img, defaultModel.nom);
  }

  function bindPreviewPanel(tabName, itemSelector) {
    var panel = root.querySelector('[data-mm-panel="' + tabName + '"]');
    if (!panel) return;
    panel.addEventListener("mouseover", function (event) {
      var link = event.target.closest ? event.target.closest(itemSelector) : null;
      if (link) updateAside(link);
    });
    panel.addEventListener("focusin", function (event) {
      var link = event.target.closest ? event.target.closest(itemSelector) : null;
      if (link) updateAside(link);
    });
    panel.addEventListener("mouseleave", function () {
      var activeTab = tabs.filter(function (tab) {
        return tab.classList.contains("is-active");
      })[0];
      if (activeTab && activeTab.getAttribute("data-mm-tab") === tabName) resetAside();
    });
  }

  bindPreviewPanel("forme", ".mm-model");
  bindPreviewPanel("selections", ".mm-selection");

  /* ---------- Onglet "Par teinte" : plusieurs montures seules à la place du trio ---------- */
  function hideMulti() {
    if (asideMulti) asideMulti.hidden = true;
    if (asideGallery) asideGallery.hidden = false;
    if (asideMeta) asideMeta.hidden = false;
    if (asideColors) asideColors.hidden = false;
    if (asideFooter) asideFooter.hidden = false;
  }

  function populateMultiSlots(items) {
    items.slice(0, multiSlots.length).forEach(function (item, index) {
      var slot = multiSlots[index];
      var frame = slot.querySelector(".mm-aside__multi-frame");
      var wornImg = slot.querySelector(".mm-aside__multi-worn");
      var badgeImg = slot.querySelector(".mm-aside__multi-badge img");
      var caption = slot.querySelector("figcaption");
      if (frame) frame.setAttribute("href", item.url);
      if (wornImg) {
        wornImg.src = item.worn || item.img;
        wornImg.alt = item.worn
          ? (item.genre === "femme" ? "Femme" : "Homme") + " portant le modèle " + item.nom
          : "Monture " + item.nom + " seule";
        wornImg.classList.add("is-visible");
      }
      if (badgeImg) {
        badgeImg.src = item.img;
        badgeImg.alt = "Monture " + item.nom + " seule";
        badgeImg.classList.add("is-visible");
      }
      if (caption) caption.textContent = item.nom;
      slot.hidden = false;
    });
  }

  function showMulti(items, key) {
    if (!asideMulti || !items || !items.length) return;
    if (key === currentMultiKey) return;
    currentMultiKey = key;
    if (asideGallery) asideGallery.hidden = true;
    if (asideMeta) asideMeta.hidden = true;
    if (asideColors) asideColors.hidden = true;
    if (asideFooter) asideFooter.hidden = true;
    clearTimeout(multiTimer);
    if (!asideMulti.hidden) {
      /* Already showing a multi preview: swap content in place, no hide/blank step,
         so switching between two teintes doesn't flash an empty panel. */
      populateMultiSlots(items);
      return;
    }
    asideMulti.hidden = false;
    multiSlots.forEach(function (slot) {
      slot.hidden = true;
      slot.querySelectorAll("img").forEach(function (img) {
        img.classList.remove("is-visible");
      });
    });
    multiTimer = setTimeout(function () {
      populateMultiSlots(items);
    }, 90);
  }

  var teintePanel = root.querySelector('[data-mm-panel="teinte"]');
  if (teintePanel) {
    var showTintTile = function (tile) {
      var raw = tile.getAttribute("data-mm-multi");
      if (!raw) return;
      showMulti(JSON.parse(raw), raw);
    };
    teintePanel.addEventListener("mouseover", function (event) {
      var tile = event.target.closest ? event.target.closest(".mm-tone") : null;
      if (tile) showTintTile(tile);
    });
    teintePanel.addEventListener("focusin", function (event) {
      var tile = event.target.closest ? event.target.closest(".mm-tone") : null;
      if (tile) showTintTile(tile);
    });
    teintePanel.addEventListener("mouseleave", function () {
      currentMultiKey = "";
      hideMulti();
      resetAside();
    });
  }

  /* ---------- Préchargement paresseux : familles au survol, packshots à l'ouverture ---------- */
  var loaded = Object.create(null);

  function preload(urls) {
    var queue = urls.filter(function (url) {
      if (!url || loaded[url]) return false;
      loaded[url] = true;
      return true;
    });
    (function step() {
      queue.splice(0, 4).forEach(function (url) {
        var img = new Image();
        img.decoding = "async";
        img.src = url;
      });
      if (queue.length) {
        if ("requestIdleCallback" in window) {
          requestIdleCallback(step, { timeout: 700 });
        } else {
          setTimeout(step, 250);
        }
      }
    })();
  }

  var packshotsLoaded = false;
  function preloadPackshots() {
    if (packshotsLoaded) return;
    packshotsLoaded = true;
    preload(
      Array.prototype.map.call(root.querySelectorAll(".mm-model[data-mm-img]"), function (link) {
        return link.getAttribute("data-mm-img");
      })
    );
  }

  var teinteImagesLoaded = false;
  function preloadTeinteImages() {
    if (teinteImagesLoaded) return;
    teinteImagesLoaded = true;
    var urls = [];
    root.querySelectorAll(".mm-tone[data-mm-multi]").forEach(function (tile) {
      var items = JSON.parse(tile.getAttribute("data-mm-multi"));
      items.forEach(function (item) {
        urls.push(item.img);
        if (item.worn) urls.push(item.worn);
      });
    });
    preload(urls);
  }

  root.querySelectorAll(".mm-family").forEach(function (family) {
    var handler = function () {
      var urls = [];
      family.querySelectorAll(".mm-model[data-mm-homme]").forEach(function (link) {
        urls.push(link.getAttribute("data-mm-homme"));
        urls.push(link.getAttribute("data-mm-femme"));
      });
      preload(urls);
    };
    family.addEventListener("mouseenter", handler);
    family.addEventListener("focusin", handler);
  });

  var details = root.closest("details");
  if (details) {
    details.addEventListener("toggle", function () {
      if (details.open) {
        preloadPackshots();
        preloadTeinteImages();
      }
    });
  }
})();
